import { useTranslation } from 'react-i18next';
import { Folder } from 'lucide-react';
import { getFileTypeIcon, getFileTypeInfo, IFileDataWithSharing } from '../utils/file-manager';

// import { CommonGridView } from './common-grid-view';
import { FileProcessingProps } from '../hooks/use-file-processing';
import { useGridViewData } from '../hooks/use-grid-view-data';
import { FileActionProps, useFileActions, useFileDetailsSheet } from './common-grid-view-helpers';
import { useCallback, useState } from 'react';
import { FileManagerGridView } from './file-manager-grid-view';
import { useIsMediaLibrary } from 'hooks/use-is-media-library';

export interface MyFileBaseGridView extends FileActionProps, FileProcessingProps {
    filters: any;
    onViewDetails?: (file: IFileDataWithSharing) => void;
    queryBuilder: (params: any) => any;
    filterFiles: (files: IFileDataWithSharing[], filters: any) => IFileDataWithSharing[];
    queryHook: (params: any, extraParams?: any) => any;
    extraParams?: any;
}

export const MyFileBaseGridView: React.FC<MyFileBaseGridView> = (props) => {
    const { t } = useTranslation();
    const isMediaLibrary = useIsMediaLibrary();
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState<IFileDataWithSharing | null>(null);

    const { data, isLoading, error, handleLoadMore, handleDelete } = useGridViewData(
        props.filters,
        props.queryBuilder,
        props.queryHook,
        props.extraParams,
        props.onDelete
    );

    const handleViewDetails = useCallback(
        (file: IFileDataWithSharing) => {
            if (isMediaLibrary) {
                return;
            }
            setSelectedFile(file);
            setIsDetailsOpen(true);
            props.onViewDetails?.(file);
        },
        [isMediaLibrary, props.onViewDetails]
    );

    const handleCloseDetails = useCallback(() => {
        setIsDetailsOpen(false);
        setSelectedFile(null);
    }, []);

    const { renderActions } = useFileActions(props, handleViewDetails, handleDelete);
    const { renderDetailsSheet } = useFileDetailsSheet(t);

    return (
        <FileManagerGridView
            onViewDetails={handleViewDetails}
            filters={props.filters}
            data={data ?? undefined}
            isLoading={isLoading}
            error={error}
            onLoadMore={handleLoadMore}
            renderDetailsSheet={renderDetailsSheet}
            getFileTypeIcon={getFileTypeIcon}
            getFileTypeInfo={getFileTypeInfo}
            renderActions={renderActions}
            emptyStateConfig={{
                icon: Folder,
                title: t('NO_FILES_FOUND'),
                description: t('NO_FILES_UPLOADED_YET'),
            }}
            sectionLabels={{
                folder: t('FOLDER'),
                file: t('FILE'),
            }}
            errorMessage={t('ERROR_LOADING_FILES')}
            loadingMessage={t('LOADING')}
            loadMoreLabel={t('LOAD_MORE')}
            filterFiles={props.filterFiles}
            isDetailsOpen={isDetailsOpen}
            selectedFile={selectedFile}
            handleCloseDetails={handleCloseDetails}
        />
    );
};
